<template>
  <div>
    <div class="content">
      <!--      <div class="content-main">-->
      <!--        <p class="content-title">用户权限</p>-->
      <!--      </div>-->
      <div class="content-main">
        <p class="content-title" style="padding-bottom: 16px;">推荐参数</p>
<!--        <div class="content-button">-->
<!--          <div>-->
<!--            <el-button type="primary" @click="editUserDialog(-1)" size="default">创建用户</el-button>-->
<!--          </div>-->
<!--          <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>-->
<!--        </div>-->
        <div class="content-table" style="padding-bottom: 12px;">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%;"
              v-loading="loading"
              size="large"
              border
              @cell-click="showEdit"
          >
            <el-table-column property="" label="系数/场景">
              <template #default="scope">
                {{scope.row.param}}
              </template>
            </el-table-column>
            <el-table-column property="" label="动态推荐" class-name="cursor">
              <template #default="scope">
                <div class="item" v-if="!scope.row.show_0">
                  <p>{{scope.row.val_0.value}}</p>
                </div>
                <div class="item" v-else>
                  <el-input type="text" v-model="scope.row.val_0.value" style="margin-right: 8px; flex: 1" @focusout="submit(scope.row.val_0)"/>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="name" label="划卡推荐" class-name="cursor">
              <template #default="scope">
                <div class="item" v-if="!scope.row.show_1">
                  <p>{{scope.row.val_1.value}}</p>
                </div>
                <div class="item" v-else>
                  <el-input type="text" v-model="scope.row.val_1.value" style="margin-right: 8px; flex: 1" @focusout="submit(scope.row.val_1)"/>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getCoeffPageList, updateCoeffList } from '../../api/url'
import { postFormData, getFormData } from "@/api/api";
import {positiveIntReg} from "@/assets/shared/reg-constant";

export default {
name: "RecommendParam",
  data() {
    return {
      pageDataList: [],
      loading: false,
    }
  },
  methods: {
    getPage() {
      let keyArr = ['x', 'y', 'k1', 'k2', 'k3', 'k4', 'z1', 'z2', 'm1', 'm2', 'n', 'l', 'f', 'g', 'h', 'j1', 'j2']
      this.loading = true;
      getFormData(getCoeffPageList).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          let dataList = data.data
          console.log(dataList)
          let arr = []
          for(let i=0; i< keyArr.length; i++) {
            let obj = {
              param: '',
              val_0: {},
              val_1: {},
            }
            obj.param = keyArr[i]
            arr.push(obj)
          }
          dataList.map((item,index) => {
            item.content = JSON.parse(item.content)
            for(let i=0; i< keyArr.length; i++) {
              for( let k in item.content) {
                if( keyArr[i] == k ) {
                  let _obj = {}
                  _obj.id = item.id
                  _obj.label = k
                  _obj.value = item.content[k]
                  arr[i]["val_"+ index] = _obj
                }
              }
            }
          })
          this.pageDataList = arr
          console.log(arr)




          // let arr = [];
          // for (let k in dataList[0]) {
          //   let obj = {
          //     param: '',
          //     val_0: '',
          //     val_1: '',
          //     val_2: '',
          //   }
          //   if(k != 'id' && k != 'adminId' && k != 'createTime' && k != 'updateTime'){
          //     obj.param = k
          //     arr.push(obj)
          //   }
          // }
          // for (let j = 0; j < dataList.length; j++) {
          //   for(let k in dataList[j]){
          //     let _obj = {}
          //     _obj.id = dataList[j].id;
          //     _obj.label = k;
          //     _obj.value = dataList[j][k];
          //     for (let i = 0; i<arr.length; i++) {
          //       if(k == arr[i].param) {
          //         arr[i]["val_"+j] = _obj
          //       }
          //     }
          //   }
          // }

          // console.log(arr)
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 200
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },

    submit(item) {
      let role = /^\d+(\.\d{1,2})?$/
      if(!role.test(item.value)) {
        this.$message({
          message: '请输入正确的数值',
          type: 'warning',
          duration: 2000
        })
        item.value = 0
        return false
      }
      let param = {}
      param['id'] = item.id;
      param['key'] = item.label
      param['value'] = item.value
      postFormData(updateCoeffList, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            message: msg,
            type: 'success',
            duration: 2000,
          })
          this.getPage()
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 2000,
          })
        }
      })
    },

    showEdit(row, column, cell, event) {
      this.pageDataList.map(item=>{
        item.show_0 = false;
        item.show_1 = false;
      })
      if(column.label == '动态推荐' && (row.val_0.value || row.val_0.value == 0)) {
        row.show_0 = true
      }
      if(column.label == '划卡推荐' && (row.val_1.value || row.val_1.value == 0)) {
        row.show_1 = true
      }
      // if (column.label == '动态推荐' && row.param != 'z2' && row.param != 'm1' && row.param != 'm2' && row.param != 'n') {
      //   row.show_0 = true
      // }
      // if (column.label == '划卡推荐' && row.param != 'z1' && row.param != 'l' && row.param != 'f' && row.param != 'g' && row.param != 'h' && row.param != 'j1' && row.param != 'j2') {
      //   row.show_1 = true
      // }
    },

  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
}
.edit-btn {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
}
.edit-btn:hover {
  background-color: #6fb6ff;
  color: #ffffff;
}
</style>
